<div class="fieldset w-100 mb-0">
  <label class="legend" for="externalmediaurl">Enter URL <span class="requiredfield">*</span></label>
  <input type="url" name="externalmediaurl" id="externalmediaurl" class="text-field" [(ngModel)]="mediaurl"
    placeholder="https://www.youtube.com/watch?v=..." required="required" (change)="urlChanged()">
</div>
<p class="text-xs text-center mt-2 mb-0">Paste a YouTube or Vimeo link. A preview appears below once it is recognised.</p>
<div #youtubediv class="d-flex justify-content-center"></div>
